import messageCatalog from '~/shared/src/utilities/messageCatalog';

import {
    MESSAGECATALOG_LOAD,
    MESSAGECATALOG_RECEIVE,
    MESSAGECATALOG_RELOAD,
    MESSAGECATALOG_SET_LANGUAGE
} from '~/frontend/src/constants';
import {
    AppDispatch,
    Thunk
} from '~/frontend/src/store';
import xhr from '~/frontend/src/utilities/xhr';
import cloneUser from '~/frontend/src/actions/user/cloneUser';
import startRequest from '~/frontend/src/actions/ajax/startRequest';
import endRequest from '~/frontend/src/actions/ajax/endRequest';


export type SetLanguageAction = {
    type : typeof MESSAGECATALOG_SET_LANGUAGE;
    language : string;
};

/**
 * @memberOf! Actions
 *
 * @param {string} language
 *
 * @return {void}
 */
export const setLanguage = ( language : string ) => {
    messageCatalog.language = language;

    return {
        type: MESSAGECATALOG_SET_LANGUAGE,
        language
    };
};


export type LoadAction = {
    type : typeof MESSAGECATALOG_LOAD;
};

/**
 * @memberOf! Actions
 *
 * @return {Promise<void>}
 */
export const load = ( retryCount : number = 0 ) : Thunk<Promise<void>> => async ( dispatch : AppDispatch ) : Promise<void> => {
    let loadOk : boolean = false;

    dispatch( {
        type: MESSAGECATALOG_LOAD
    } );

    dispatch( startRequest(
        () => {
        },
        'global_non_masking',
        'loadProcessingMessageCatalog'
    ) );

    const result = await xhr.post(
        `${BASE_URL}/api/messagecatalog/load`,
        undefined,
        undefined,
        'global_non_masking',
        'loadMessageCatalog',
        dispatch
    );

    if ( result?.data.data ) {
        const data = result?.data.data;

        if ( data?.messageData ) {
            loadOk = messageCatalog.fromJsonString( data.messageData, data.messageDataTimestamp );
        }
    }

    if ( loadOk ) {
        dispatch( cloneUser() );
    }

    dispatch( endRequest(
        () => {
        },
        'global_non_masking',
        'loadProcessingMessageCatalog'
    ) );

    if ( loadOk ) {
        dispatch( receive( result?.data.data ) );
    }
    else if ( retryCount < 10 ) {
        void dispatch( load( retryCount++ ) );
    }
};
export type Load = typeof load;


export type ReloadAction = {
    type : typeof MESSAGECATALOG_RELOAD;
};

/**
 * @memberOf! Actions
 *
 * @return {Promise<void>}
 */
export const reload = ( retryCount : number = 0 ) : Thunk<Promise<void>> => async ( dispatch : AppDispatch ) : Promise<void> => {
    let reloadOk : boolean = false;

    dispatch( {
        type: MESSAGECATALOG_RELOAD
    } );

    dispatch( startRequest(
        () => {
        },
        'global_non_masking',
        'reloadProcessingMessageCatalog'
    ) );

    const result = await xhr.post(
        `${BASE_URL}/api/messagecatalog/reload`,
        undefined,
        undefined,
        'global_non_masking',
        'reloadMessageCatalog',
        dispatch
    );

    if ( result?.data.data ) {
        const data = result?.data.data;

        if ( data?.messageData ) {
            reloadOk = messageCatalog.fromJsonString( data.messageData, data.messageDataTimestamp );
        }
    }

    if ( reloadOk ) {
        dispatch( cloneUser() );
    }

    dispatch( endRequest(
        () => {
        },
        'global_non_masking',
        'reloadProcessingMessageCatalog'
    ) );

    if ( reloadOk ) {
        dispatch( receive( result?.data.data ) );
    }
    else if ( retryCount < 10 ) {
        void dispatch( reload( retryCount++ ) );
    }
};
export type Reload = typeof reload;


export type ReceiveAction = {
    type : typeof MESSAGECATALOG_RECEIVE;
};

/**
 * @memberOf! Actions
 *
 * @param {any} data
 *
 * @return {void}
 */
const receive = ( data : any ) => {
    return {
        type: MESSAGECATALOG_RECEIVE,
        data
    };
}
export type Receive = typeof receive;
